import React, { useEffect, useState } from 'react'
import { plural } from '../../../../shared/sso-workspace/format'
import { IconCheck, IconFileZip } from '../../../../shared/icon/icon'
import { MenuItem } from '../../../../shared/menu/menu'
import { KINDS } from './ai-tools-download'
import { useDownload } from './download-button'
import { MarkMatchingDialog } from './mark-matching-dialog'
import { markedText } from './mark-dialog'

// The Sessions and Postmortems lists' actions, as the list card's menu items
// (owner 2026-10-29: "use our menu system like everywhere else", so every
// header button is the same size and style and the rest folds into the ⋮):
// Download (everything the filters match, as a file; pinned, and kept a
// button on a phone) and, with SYS_AI_TOOLS_TELEMETRY update, Mark all
// matching… (in the ⋮, beside the list's Delete all matching…). Once the grid
// knows how many rows the filters match (list.total) they say it: "Download 2
// sessions", "Mark 2 sessions…"; with none, both are held. The export takes
// neither the grid's search nor the person filter, so while either is on
// Download is held and says so (it would hold other rows than the list
// shows). It remembers the tab's last completed download, so the mark dialog
// can offer "what you downloaded at 3:05 PM". After marks the list says how
// many and starts again at the top (list.wrote).
//
// list: useMarkableList's; kind: 'session' | 'postmortem'; filters: the tab's
// list filters (the person's login_id among them); fromDay, toDay: the chosen
// local dates (the file's name).
// -> { items, notice, dialog } for MarkableList's actions: the menu items,
// the card's status line (a running download, what it or a mark last said)
// and the open dialog.

export const useMatchingActions = ({ list, kind, filters, fromDay, toDay }) => {
  const [last, setLast] = useState(null)
  const [dialog, setDialog] = useState(false)
  // whose words the status line shows: the newest of the download's and the list's
  const [latest, setLatest] = useState('list')
  const spec = KINDS[kind]
  const known = Number.isFinite(list.total)
  const none = known && list.total === 0
  const held = !!list.blocked || none
  // the export takes every filter the list does, its search and person too,
  // so a download holds the rows the list shows
  const exported = list.search ? { ...filters, q: list.search } : filters

  const download = useDownload({ kind, filters: exported, fromDay, toDay, disabled: held, onDone: setLast,
    onStart: () => setLatest('download'),
    label: known ? `Download ${plural(list.total, spec.noun)}` : 'Download' })
  useEffect(() => { if (list.said) setLatest('list') }, [list.said])

  const finished = answer => {
    setDialog(false)
    list.wrote(markedText(kind, answer), { marks: true })
  }

  const items = [
    ...download.items,
    <MenuItem key="mark-all" Icon={IconCheck} text={known ? `Mark all ${plural(list.total, spec.noun)}` : 'Mark all matching'} show={!!list.canMark} disabled={held}
      onClick={() => { list.say(null); setDialog('matching') }} />,
    // marking what a download holds is its own flow, not the table's (owner 2026-10-29)
    <MenuItem key="mark-file" Icon={IconFileZip} text="Mark downloaded file" show={!!list.canMark}
      onClick={() => { list.say(null); setDialog('download') }} />
  ]
  const notice = latest === 'download' ? download.notice || list.notice : list.notice || download.notice

  return {
    items,
    notice,
    dialog: dialog && <MarkMatchingDialog kind={kind} mode={dialog} filters={list.search ? { ...filters, q: list.search } : filters} last={last} consumers={list.consumers} onCancel={() => setDialog(false)} onDone={finished} />
  }
}
